const DELETED_USER_LABELS = new Set([
  'пользователь удален',
  'user deleted',
]);

export function isDeletedUserLabel(value: string) {
  const normalized = value
    .trim()
    .replace(/\s+/g, ' ')
    .replace(/ё/g, 'е')
    .replace(/^(?:перевозчик|carrier)\s+/i, '')
    .toLocaleLowerCase('ru-RU');

  return DELETED_USER_LABELS.has(normalized) || normalized.endsWith('@deleted.invalid');
}

export function carrierOfferLabel(value: string, isDeleted = false) {
  if (isDeleted || isDeletedUserLabel(value)) return 'Пользователь удален';

  const parts = value.trim().split(/\s+/).filter(Boolean);
  const compactName = parts.length < 2 ? value : `${parts[0]} ${parts[1][0]}.`;
  return `Перевозчик ${compactName}`;
}
